import { Button, Indicator, Tooltip } from "@mantine/core";
import { IconBell } from "@tabler/icons-react";
import { setShowNotificationsInRedux } from "../global/globalSlice";
import { useAppDispatch, useAppSelector } from "../hooks";

export const NotificationButton = () => {
  const user = useAppSelector((state) => state.globalReducer.user);
  const notifications = user ? user.notifications : [];

  const dispatch = useAppDispatch();

  const hasUnreadNotifications = notifications.some((notification) => notification.markedAsRead?.value === false);

  const showNotification = useAppSelector((state) => state.globalReducer.showNotifications);

  return (
    <Tooltip label="Vis notifikasjoner" withArrow>
      <Indicator
        disabled={!hasUnreadNotifications}
        inline
        size={10}
        offset={10}
        position="top-end"
        color="orange.5"
      >
        <Button
          variant="subtle"
          c={"white"}
          size="compact-xl"
          onClick={() => {
            const next = !showNotification;
            dispatch(setShowNotificationsInRedux(next));
          }}
        >
          <IconBell size={20} />
        </Button>
      </Indicator>
    </Tooltip>
  );
};
